import 'css-chunk:../../src/components/dismissible-button/index.module.scss';export default {
  "button": "_button_1z0ca_1",
  "label": "_label_1z0ca_21",
  "close": "_close_1z0ca_26"
};